export default __webpack_public_path__ + "static/media/TECH_INSIDE_BACKGROUND.d9365877.png";